import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const GalileoBenchmarkPage = lazy(
	() => import("../pages/galileo/benchmark/components/BenchmarkPage"),
);
const GalileoSearchPage = lazy(
	() => import("../pages/galileo/search/components/SearchPage"),
);

export const galileoRoutes: RouteObject[] = [
	{
		path: ROUTES.GALILEO,
		element: protectedRoute(<GalileoBenchmarkPage />),
	},
	{
		path: ROUTES.GALILEO_BENCHMARKS,
		element: protectedRoute(<GalileoBenchmarkPage />),
	},
	{
		path: ROUTES.GALILEO_SEARCH,
		element: protectedRoute(<GalileoSearchPage />),
	},
];
